import BaseTween from './base-tween'

/**
 * The basic tween class used for stright tweens.
 *
 * @param  {PIXI.Sprite}  sprite            the sprite to tween
 * @param  {string}  property               the sprite property to modify
 * @param  {number}  startValue             the starting value
 * @param  {number}  endValue               the ending value
 * @param  {number}  duration               the number of frames that the tween will take to complete
 * @param  {String}  [type='smoothstep']    the type of easing
 * @param  {Boolean} [yoyo=false]           should the sprite yoyo
 * @param  {Number}  [delayBeforeRepeat=0]  Delay in frames before repeating
 */
export default class Tween extends BaseTween {
  constructor (
    sprite,
    property,
    startValue,
    endValue,
    duration,
    type = 'smoothstep',
    yoyo = false,
    delayBeforeRepeat = 0
  ) {
    super(sprite, [startValue, endValue], duration, type, yoyo, delayBeforeRepeat)

    this.property = property
  }

  _setUpForYoyo () {
    this.data = this.data.reverse()
  }

  _setUpForEnd () {
    this.sprite[this.property] = this.data[1]
  }

  _modifyProperty (curvedTime) {
    this.sprite[this.property] = (this.data[1] * curvedTime) + (this.data[0] * (1 - curvedTime))
  }
}



// WEBPACK FOOTER //
// ./src/tween.js